import React from 'react'
import { ExternalLink } from 'components/base/Text'

const openIntercom = e => {
  e.preventDefault()
  window.Intercom
    ? window.Intercom('show')
    : window.open('mailto:contact@slite.com')
}

export default function MetaSupport() {
  return (
    <ExternalLink inline onClick={openIntercom}>
      Message us
    </ExternalLink>
  )
}
